// eslint-disable-next-line max-classes-per-file
const internalType = 'INTERNAL';
export class OutdatedServerVersionError extends Error {
  constructor(message) {
    super(message);
    this.name = 'OutdatedServerVersionError';
    this.type = internalType;
    this.handledByBoundary = true;
  }
}

export class SessionExpiredError extends Error {
  constructor(message) {
    super(message);
    this.name = 'SessionExpiredError';
    this.type = internalType;
    this.handledByBoundary = true;
  }
}
export class ErrorWithHTTPStatusCode extends Error {
  constructor(code) {
    super(`Received HTTP status code ${code}`);
    this.code = code;
    this.handledByBoundary = false;
  }
}

export function isInternalError(error) {
  return error.type === internalType;
}
